import firebase from 'firebase';
import 'firebase/firestore';
import firebaseConfig from './firebaseConfig';
const firebaseApp = firebase.initializeApp(firebaseConfig);
const storage = firebaseApp.storage();
const auth = firebaseApp.auth();
const db = firebaseApp.firestore();
export {
  storage,
  db,
  auth
};




// WEBPACK FOOTER //
// ./src/api/firebaseInit.js